// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"895e686d","455":"5f52b07a","977":"e962587a"}[chunkId] + ".chunk.js";
};